export function calculateAge(birthday: string, date: string): number {
    // Parse the birthday string into a Date object
    const birthDate = new Date(birthday);

    // Get today's date
    const dateD = new Date(date);

    // Calculate the difference in years
    let age = dateD.getFullYear() - birthDate.getFullYear();

    // Adjust if the birthday hasn't occurred yet this year
    const isBirthdayPassedThisYear =
        dateD.getMonth() > birthDate.getMonth() ||
        (dateD.getMonth() === birthDate.getMonth() && dateD.getDate() >= birthDate.getDate());

    if (!isBirthdayPassedThisYear) {
        age--;
    }

    return age;
}

export function isValidDate(year: string, month: string, day: string, minAge = 0, maxAge = 99): boolean {
    const y = parseInt(year);
    const m = parseInt(month);
    const d = parseInt(day);

    if (!y || !m || !d) return false;

    const date = new Date(y, m - 1, d);
    if (
        isNaN(date.getTime()) ||
        date.getFullYear() !== y ||
        date.getMonth() !== m - 1 ||
        date.getDate() !== d
    ) {
        return false;
    }

    // Age validation
    const today = new Date();
    let age = today.getFullYear() - y;

    const monthDiff = today.getMonth() - (m - 1);
    const dayDiff = today.getDate() - d;

    if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age--;
    }

    return age >= minAge && age <= maxAge;
}

export function calculateDaysDifference(dateStr1: string, dateStr2: string): number {
    const date1 = new Date(dateStr1);
    const date2 = new Date(dateStr2);

    // Calculate the difference in milliseconds
    const differenceInTime = Math.abs(date2.getTime() - date1.getTime());

    // Convert the difference from milliseconds to days
    const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));

    return differenceInDays;
}